import { render, staticRenderFns } from "./Families.vue?vue&type=template&id=17742de4&scoped=true"
import script from "./Families.vue?vue&type=script&lang=js"
export * from "./Families.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17742de4",
  null
  
)

export default component.exports